import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import FeasibilityTable from 'src/components/StartUp/feasibilityQuestionnaires/FeasibilityTable';
import FeasibilityForm from 'src/components/StartUp/feasibilityQuestionnaires/feasibilityForm';

const initialState: any = {
  showCMPArr: [
    {
      cmp: FeasibilityTable,
      key: 'feasibilityTable',
      curruntlyActive: true
    },
    {
      cmp: FeasibilityForm,
      key: 'feasibilityForm',
      curruntlyActive: false
    }
  ],
  selectedformData: {}
};

export const feasibility = createSlice({
  name: 'feasibility',
  initialState,
  reducers: {
    setShowCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedformData: (state: any, action: any) => {
      state.selectedformData = action.payload;
    }
  }
});

export const { setShowCMPArr, setSelectedformData } = feasibility.actions;
